import { Entity } from '../base/entity';

export class ItemTool extends Entity {
    public static readonly TABLENAME = 'item_tool';

    public static readonly ITEM_ID = "item_id";
    public static readonly OPERATION_ID = "tool_id";
    public static readonly QUANTITY = "quantity";
    
    itemId : String;
    toolId : number;
    quantity : String;
}